import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Subscriber } from '../classes/index';

@Injectable()
export class SubscriberService {

	constructor(private firestore: Firestore) {
		console.log('SubscriberService initialization...');
	}

	findSubscriber(email){
		return collectionData(query(collection(this.firestore, 'subscribers'), where('email', '==', email)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let subscriber = new Subscriber();
				subscriber.fromJSON(data);
				return subscriber;
			});
		}));
	}

	deleteSubscriber(id) {
		return deleteDoc(doc(this.firestore, 'subscribers', id));
	}
}
